export { DMS_MODULE } from '../../constants';
export const NAME = 'EventFrequency';
export const CRUMB_LABEL_KEY = 'DefineDeliveryRules';
export const CRUMB_LABEL_EDIT = 'edtDefineDeliverRules';
export const CRUMB_LABEL_LIST = 'grdDefineDeliverRules';

export enum EventFrequencies {
	OnlyOnce = 1,
	Daily = 2,
	Weekly = 3,
	Monthly = 4,
	Quarterly = 5,
}
